export function kbSizeToString(mv: number) {
	return +mv.toFixed(1) < 1024 ? mv + " kb" : (mv / 1024).toFixed(1) + " MB"
}